import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './Login.css';
import './i18n';
import { msalInstance } from "./authConfig";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { getMsalInstance } from "./authConfig";


const root = ReactDOM.createRoot(document.getElementById('root'));
getMsalInstance().then((msalInstance) => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
}).catch((error) => {
  console.error("MSAL initialization failed:", error);
});
reportWebVitals();
